import './App.css';
import Navbar from "./Components/Navbar";
import AddBooks from './Pages/AddBooks';
import Books from './Pages/Books';
import Home from "./Pages/Home";
import Footer from './Components/Footer';
import { BrowserRouter as Router,Routes,Route } from "react-router-dom";
import UpdateBook from './Pages/UpdateBook';
function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Home />}/>
        <Route  path="/books" element={<Books />}/>
        <Route path="/addBooks" element={<AddBooks />}/>
        <Route path="/updateBook/:id" element={<UpdateBook />}/>
      </Routes>
       <Footer />
    </Router>
  );
}

export default App;
